import {
  ROLE_ACCOUNTANT,
  ROLE_CLINIC_ADMINISTRATOR,
  ROLE_FINANCIAL,
  ROLE_FINANCIAL_ADMINISTRATOR,
  ROLE_OTHER_HEALTH_PROFESSIONAL,
  ROLE_PARTNERSHIP,
  ROLE_PROFESSIONAL,
  ROLE_RECEPTIONIST,
  ROLE_STOCK
} from './types';
import display from './display';

const roles = [
  {
    id: '4f9abe71-941b-46ba-b0e0-f71e38e824ec',
    name: ROLE_PROFESSIONAL,
    description: display.ROLES[ROLE_PROFESSIONAL]
  },
  {
    id: '35c8fb74-f40f-4de6-a7a5-04849447c620',
    name: ROLE_CLINIC_ADMINISTRATOR,
    description: display.ROLES[ROLE_CLINIC_ADMINISTRATOR]
  },
  {
    id: '08359ad6-1960-45a0-b6da-3705896ee0ed',
    name: ROLE_OTHER_HEALTH_PROFESSIONAL,
    description: display.ROLES[ROLE_OTHER_HEALTH_PROFESSIONAL]
  },
  {
    id: '5e930487-4304-47b9-b6c2-7d3be7095bdb',
    name: ROLE_RECEPTIONIST,
    description: display.ROLES[ROLE_RECEPTIONIST]
  },
  {
    id: 'f814275b-3480-42e8-8120-35f39aa8b456',
    name: ROLE_ACCOUNTANT,
    description: display.ROLES[ROLE_ACCOUNTANT]
  },
  {
    id: '821ade28-e27e-41b6-841b-ff1c1a86f0a7',
    name: ROLE_FINANCIAL,
    description: display.ROLES[ROLE_FINANCIAL]
  },
  {
    id: '9f21af74-dd09-42c8-bbb9-a901f01b7c31',
    name: ROLE_PARTNERSHIP,
    description: display.ROLES[ROLE_PARTNERSHIP]
  },

  {
    id: '8d364b69-f9d4-4f6a-af57-e5b4afdd1a09',
    name: ROLE_FINANCIAL_ADMINISTRATOR,
    description: display.ROLES[ROLE_FINANCIAL_ADMINISTRATOR]
  },
  {
    id: '8845cc66-b911-483e-b95f-cfc4775fa541',
    name: ROLE_STOCK,
    description: display.ROLES[ROLE_STOCK]
  }
];

export default roles;
